import styled from "styled-components";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import Textarea from "../Textarea";
import Modal from "../Modal";

type RejectModalProp = {
  setOpenOrClose: () => void;
  onRejectCall: () => void;
  handleChange: (e: any) => void;
  error: string;
  headerTitle: string;
  placeholderText: string;
  labelText: string;
  textAreaValue: string;
  buttonLabel: string;
};

const RejectModal = ({
  setOpenOrClose,
  onRejectCall,
  handleChange,
  error,
  headerTitle,
  placeholderText,
  labelText,
  textAreaValue,
  buttonLabel,
}: RejectModalProp) => {
  return (
    <Modal setOpenOrClose={setOpenOrClose} variant="none" width="21.2rem">
      <StyledRejectModal>
        <RejectModalHeader>
          <HeaderTitle>{headerTitle}</HeaderTitle>
          <Close
            src={require("../../assets/images/ei_close.png")}
            alt="close"
            onClick={setOpenOrClose}
          />
        </RejectModalHeader>
        <RejectModalBody>
          <Textarea
            placeholder={placeholderText}
            label={labelText}
            required
            onChange={handleChange}
            value={textAreaValue}
            error={error ? true : false}
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <ButtonWrapper>
            <Button
              label={buttonLabel}
              variant="filled"
              color={Colors.appleRed}
              size="medium"
              isRounded={true}
              onClick={() => {
                onRejectCall();
              }}
            />
          </ButtonWrapper>
        </RejectModalBody>
      </StyledRejectModal>
    </Modal>
  );
};

export default RejectModal;

const StyledRejectModal = styled.div`
  padding: 1.625rem 2.2rem 1.8rem 2.25rem;
`;

const RejectModalHeader = styled.div`
  display: flex;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;

const Close = styled.img`
  transform: translate(3.375rem, -0.25rem);
  cursor: pointer;
`;

const RejectModalBody = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

const ErrorMessage = styled.div`
  font-family: "Poppins-Book";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  padding-top: 0.5rem;
`;
